import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import ConversationTopicsMultiSelectV2 from 'components/customer/conversation_history/topics_v2/conversation_topics_multi_select_v2';
import i18n from 'scripts/i18n/i18n';
import registerHotkey from 'components/hotkeys/register_hotkey';
import { TopicsMenuOptionType } from 'components/customer/conversation_history/topics_v2/conversation_topics_constants_v2';
import withShortcuts from 'scripts/presentation/decorators/keypress_shortcut_decorator';

export class ConversationTopicsBaseV2 extends PureComponent {
  render() {
    return (
      <ConversationTopicsMultiSelectV2
        {...this.props}
        label={i18n.t('Topics')}
        onClose={this.props.onMenuClose}
        onOpen={this.props.onMenuOpen}
        onOptionChange={this.props.onTopicChange}
        onSearch={this.props.onTopicSearch}
        onSelect={this.props.onTopicSelect}
        optionIds={this.props.conversation.topicIds}
        options={this.props.topics.concat(...this.props.customAttributes)}
        placeholder={i18n.t('Add a Topic')}
        ref={multiSelect => (this.multiSelect = multiSelect)}
        selectedCustomAttributes={this.props.conversation.customAttributes}
        suggestedIds={this.props.topicSuggestions && this.props.topicSuggestions.addTopics}
        suggestedLabel={i18n.t('Suggested Topics')}
        unitLabelPlural={i18n.t('Topics')}
        unitLabelSingular={i18n.t('Topic')}
        unselectedLabel={i18n.t('All Topics')}
      />
    );
  }
}

ConversationTopicsBaseV2.propTypes = {
  className: PropTypes.string,
  dropDown: PropTypes.bool,
  hideSelectedOptions: PropTypes.bool,
  conversation: PropTypes.object.isRequired,
  customAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      disabled: PropTypes.bool,
      type: PropTypes.oneOf([TopicsMenuOptionType.CUSTOM_ATTRIBUTE]),
    })
  ),
  onFocus: PropTypes.func,
  onMenuClose: PropTypes.func,
  onMenuOpen: PropTypes.func,
  onMenuOpenChange: PropTypes.func,
  onTopicChange: PropTypes.func.isRequired,
  openRequestedAt: PropTypes.string,
  onTopicSearch: PropTypes.func,
  onTopicSelect: PropTypes.func,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      disabled: PropTypes.bool,
      type: PropTypes.oneOf([TopicsMenuOptionType.TOPIC]),
    })
  ),
  topicSuggestions: PropTypes.object,
};

export default withShortcuts(ConversationTopicsBaseV2, [
  registerHotkey({
    key: 'alt+t',
    callback: component => {
      component.multiSelect.handleMenuOpenerClick();
    },
    group: 'Conversation',
    label: 'Edit topics',
  }),
]);
